import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const customerApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer",
      params,
    }),
  findReminders: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer/reminders",
      params,
    }),
  updateContactInterval: (id: number, data: { contactIntervalDays: number }): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/contact-interval`,
      method: "patch",
      data,
    }),
  reject: (id: number, data: { reason: string; note?: string }): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/reject`,
      method: "patch",
      data,
    }),
  unreject: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/unreject`,
      method: "patch",
    }),
  findTags: (): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer/tags",
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
      method: "patch",
      data,
    }),
  findDebts: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/debts`,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
      method: "delete",
    }),
  importExcel: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/v1/admin/customer/import",
      method: "post",
      data: formData,
      timeout: 120000,
    });
  },
};
